// src/utils/assessmentUtils.js

export const ASSESSMENT_KINDS = {
  REGULAR: 'regular',
  GRADE_LEVEL: 'gradeLevel'
};

export const ASSESSMENT_POOLS = {
  POOLED: 'Pooled',
  NON_POOLED: 'NonPooled',
  NA: 'NA'
};

export function getDefaultAssessmentPool(assessmentKind) {
  return assessmentKind === ASSESSMENT_KINDS.REGULAR 
    ? ASSESSMENT_POOLS.NON_POOLED 
    : ASSESSMENT_POOLS.NA;
}

export function normalizeAssessment(assessment) {
  if (!assessment) return null;
  
  const assessmentPool = assessment.assessmentPool 
    ? assessment.assessmentPool.charAt(0).toUpperCase() + assessment.assessmentPool.slice(1).toLowerCase()
    : getDefaultAssessmentPool(assessment.assessmentKind);
  
  const normalized = {
    ...assessment,
    assessmentKind: assessment.assessmentKind || ASSESSMENT_KINDS.GRADE_LEVEL,
    assessmentPool
  };

  // For regular assessments, ensure each question has its own Direction, Image, and ReadingPassage.
  if (
    normalized.assessmentKind === ASSESSMENT_KINDS.REGULAR &&
    normalized.Grades &&
    Array.isArray(normalized.Grades) &&
    normalized.Grades.length > 0
  ) {
    const gradeBlock = normalized.Grades[0];
    const commonDirection = gradeBlock.Direction || '';
    const commonImage = gradeBlock.Image || '';
    const commonReadingPassage = gradeBlock.ReadingPassage || '';
    
    if (gradeBlock.Questions && Array.isArray(gradeBlock.Questions)) {
      gradeBlock.Questions = gradeBlock.Questions.map((question) => ({
        ...question,
        Direction:
          (question.Direction && question.Direction.trim() !== '')
            ? question.Direction
            : commonDirection,
        Image:
          (question.Image && question.Image.trim() !== '')
            ? question.Image
            : commonImage,
        ReadingPassage:
          (question.ReadingPassage && question.ReadingPassage.trim() !== '')
            ? question.ReadingPassage
            : commonReadingPassage,
      }));
    }
    normalized.Grades[0] = gradeBlock;
  }

  return normalized;
}

export const calculateGradePerformance = (responses, correctAnswers, gradeStartIndex, gradeEndIndex) => {
  let correctCount = 0;
  for (let i = gradeStartIndex; i <= gradeEndIndex; i++) {
    if (responses[i] === correctAnswers[i]) {
      correctCount++;
    }
  }
  return correctCount;
};

export const getGradeIndexFromQuestionNumber = (questionNumber) => {
  return Math.ceil(questionNumber / 5);
};

export const getQuestionRange = (gradeIndex) => {
  const start = ((gradeIndex - 1) * 5) + 1;
  const end = start + 4;
  return { start, end };
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const getAssessmentTypeName = (type) => {
  const types = {
    'reading': 'Reading Comprehension Assessment',
    'calculation': 'Math Calculation Assessment',
    'problem-solving': 'Math Problem Solving Assessment'
  };
  return types[type] || type;
};
